<form [formGroup]="copyAttributesGroup">
  <mat-form-field>
    <mat-select formControlName="city_selection" multiple (selectionChange)="selectionChange()" placeholder="Select City"
                (openedChange)="onDropdownOpened($event, searchValue)">
      <mat-select-trigger>
        <mat-chip-set>
          <mat-chip *ngFor="let city of copyAttributesGroup.value.city_selection" [removable]="true" (removed)="onCityRemoved(city)">
            {{ city.viewValue }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-set>
      </mat-select-trigger>

      <!-- Search Input -->
      <mat-form-field class="search-field">
        <input matInput #searchValue (input)="filterCities($event.target.value)" placeholder="Search cities">
      </mat-form-field>
      <mat-checkbox class="city-checkbox" [checked]="isAllSelected" (change)="selectAll($event.checked)"> Select All </mat-checkbox>
      <!-- City Options -->
      <ng-container *ngFor="let city of filteredCities">
        <mat-option *ngIf="city.value != api.city_id" [value]="city">
          {{ city.viewValue }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>

  <div class="footer gap-20" fxLayout="row" fxLayoutAlign="center center">
    <div>
      <button class="paste-btn" (click)="submit()" [disabled]="copyAttributesGroup.value.city_selection.length == 0">Paste</button>
    </div>
    <div>
      <button (click)="cancel()" class="cancel-btn">Cancel</button>
    </div>
  </div>
</form>
   <!-- loader start -->
   <div *ngIf="loader" class='loader-div'>
    <ngx-loading [show]="loader"></ngx-loading>
  </div>
  <!-- loader end -->
